import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

interface eleitorSemPlanoData {
  idEleicao: number,
  token: string,
  eleitor?: any,
  editandoEleitor?: boolean,
  confirmarCallback?: () => void
}

@Component({
  selector: 'app-confirma-eleitor-sem-plano',
  templateUrl: './confirma-eleitor-sem-plano.component.html',
  styleUrls: ['./confirma-eleitor-sem-plano.component.scss']
})

export class ModalConfirmaEleitorSemPlanoComponent implements OnInit {
  title: string;
  closeBtnName: string;
  header: string;
  eleitorSemPlanoData: eleitorSemPlanoData;
  token: string;
  idEleicao: number;
  novoEleitor: any;
  editandoEleitor: boolean = false;

  constructor(
    public bsModalRef: BsModalRef
  ) { }

  ngOnInit() {
    this.token = this.eleitorSemPlanoData.token;
    this.novoEleitor = this.eleitorSemPlanoData.eleitor;
    this.editandoEleitor = this.eleitorSemPlanoData.editandoEleitor;
    this.idEleicao = this.eleitorSemPlanoData.idEleicao;
  }

  confirmarSemPlano() {
    if (this.eleitorSemPlanoData.confirmarCallback) {
      this.eleitorSemPlanoData.confirmarCallback();
    }
    this.bsModalRef.hide();
  }

  cancelar() {
    this.bsModalRef.hide();
  }
}